"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TRANSLATION = exports.TEXT = exports.ORIGIN_URL = exports.MISMATCH_ERROR = exports.MEMBER_TYPES = exports.MEMBER_ICONS = exports.LOADING_GIF = exports.ICONS = exports.FIELDS = exports.ENVIRONMENT_URL = exports.ENVIRONMENT = exports.EMAIL_REGEX = exports.DEFAULT_THEME = exports.DEFAULT_ENV = exports.BIG_LOYALTY_MONOGRAM_ALT = exports.BIG_LOYALTY_MONOGRAM = exports.BIGMEMBER_DOB_REGEX = exports.BIGLOYALTY_ICON = exports.AWS_CONFIG = exports.AUTH_URL = void 0;
var _statics = require("./statics");
/* eslint-disable max-len */

var BIGLOYALTY_ICON = _statics.BigLoyalty;
exports.BIGLOYALTY_ICON = BIGLOYALTY_ICON;
var MEMBER_ICONS = {
  T1: _statics.MemberBlack,
  T2: _statics.MemberGold,
  T3: _statics.MemberPlatinum,
  T4: _statics.MemberRed
};
exports.MEMBER_ICONS = MEMBER_ICONS;
var MEMBER_TYPES = Object.keys(MEMBER_ICONS);
exports.MEMBER_TYPES = MEMBER_TYPES;
var BIG_LOYALTY_MONOGRAM = 'https://static.stgairasia.com/design/icons/app-rewards/ic_rewards.svg';
exports.BIG_LOYALTY_MONOGRAM = BIG_LOYALTY_MONOGRAM;
var BIG_LOYALTY_MONOGRAM_ALT = 'Big loyalty Monogram';
exports.BIG_LOYALTY_MONOGRAM_ALT = BIG_LOYALTY_MONOGRAM_ALT;
var ICONS = {
  ICON_NAMES: {
    EXPAND_MORE_ICON: 'ExpandMoreIcon',
    EXPAND_LESS_ICON: 'ExpandLessIcon'
  },
  SIZE: 'titleNormal',
  COLOR: 'greyDark'
};
exports.ICONS = ICONS;
var DEFAULT_THEME = 'AIRASIA_CLASSIC';
exports.DEFAULT_THEME = DEFAULT_THEME;
var LOADING_GIF = 'https://a.staticaa.com/images/web-apps/component/flight-search/loading-circle.gif';

// eslint-disable-next-line
exports.LOADING_GIF = LOADING_GIF;
var EMAIL_REGEX = /^(?=.{1,64}@)(([^<>()\\[\]\\.,;:\s@"]+(\.[^<>()\\[\]\\.,;:\s@"]+)*)|(".+"))@(?!.{65})(((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,})))$/;
exports.EMAIL_REGEX = EMAIL_REGEX;
var TRANSLATION = {
  bigMemberId: 'BIG member ID ',
  earnBigPointsGuest: 'Earn BIG Points for this guest',
  earnBigPoints: 'Earn BIG Points',
  searchSubtitle: 'Search the BIG Member ID using the email address registered to this guest',
  earnUpTo: 'Earn up to',
  search: 'Search',
  points: 'points',
  detailedInvalidEmailMessage: 'Please enter a valid email (example@email.com)',
  noData: 'We are unable to fetch any details now. Try again later in manage booking',
  unavailable: 'Unavailable'
};
exports.TRANSLATION = TRANSLATION;
var TEXT = {
  inlineFlex: 'inlineFlex',
  displayFlex: 'displayFlex',
  default: 'default',
  greyDarker: 'greyDarker',
  greyDark: 'greyDark',
  small: 'small',
  icon: 'loyalty-icon',
  loading: 'loading',
  size: '18px',
  unavailableColor: 'orange',
  defaultColor: 'neutral',
  primary: 'primary'
};
exports.TEXT = TEXT;
var MISMATCH_ERROR = 'USER_NAME_MISMATCH';
exports.MISMATCH_ERROR = MISMATCH_ERROR;
var ENVIRONMENT = ['DEVELOPMENT', 'STAGING', 'PRE_PRODUCTION', 'PRODUCTION'];
exports.ENVIRONMENT = ENVIRONMENT;
var DEFAULT_ENV = 'STAGING';
exports.DEFAULT_ENV = DEFAULT_ENV;
var ENVIRONMENT_URL = {
  v1: {
    DEVELOPMENT: {
      NAV_URL: 'https://ssor.devairasia.com/um/v2/user-navitaire-info'
    },
    STAGING: {
      NAV_URL: 'https://ssor.stgairasia.com/um/v2/user-navitaire-info'
    },
    PRE_PRODUCTION: {
      NAV_URL: 'https://ssor.airasia.com/um/v2/user-navitaire-info'
    },
    PRODUCTION: {
      NAV_URL: 'https://ssor.airasia.com/um/v2/user-navitaire-info'
    }
  },
  v2: {
    DEVELOPMENT: {
      NAV_URL: 'https://loki.airasiabig.com/v1/internal/member/match?firstName={{fName}}&lastName={{lName}}&dob={{dob}}'
    },
    STAGING: {
      NAV_URL: 'https://loki.airasiabig.com/v1/internal/member/match?firstName={{fName}}&lastName={{lName}}&dob={{dob}}'
    },
    PRE_PRODUCTION: {
      NAV_URL: 'https://loki.airasiabig.com/v1/internal/member/match?firstName={{fName}}&lastName={{lName}}&dob={{dob}}'
    },
    PRODUCTION: {
      NAV_URL: 'https://titan.airasiabig.com/v1/internal/member/match?firstName={{fName}}&lastName={{lName}}&dob={{dob}}'
    }
  }
};
exports.ENVIRONMENT_URL = ENVIRONMENT_URL;
var AUTH_URL = {
  DEVELOPMENT: {
    NAV_URL: 'https://ssor.devairasia.com/config/v2/clients/by-origin'
  },
  STAGING: {
    NAV_URL: 'https://ssor.stgairasia.com/config/v2/clients/by-origin'
  },
  PRE_PRODUCTION: {
    NAV_URL: 'https://ssor.airasia.com/config/v2/clients/by-origin'
  },
  PRODUCTION: {
    NAV_URL: 'https://ssor.airasia.com/config/v2/clients/by-origin'
  }
};
exports.AUTH_URL = AUTH_URL;
var ORIGIN_URL = {
  DEVELOPMENT: {
    NAV_URL: 'https://www.devairasia.com/'
  },
  STAGING: {
    NAV_URL: 'https://www.stgairasia.com'
  },
  PRE_PRODUCTION: {
    NAV_URL: 'https://www.ppairasia.com/'
  },
  PRODUCTION: {
    NAV_URL: 'https://www.airasia.com/'
  }
};
exports.ORIGIN_URL = ORIGIN_URL;
var FIELDS = {
  firstName: 'fName',
  lastName: 'lName',
  email: 'email',
  dateOfBirth: 'dob'
};
exports.FIELDS = FIELDS;
var BIGMEMBER_DOB_REGEX = /^\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1])$/;
exports.BIGMEMBER_DOB_REGEX = BIGMEMBER_DOB_REGEX;
var AWS_CONFIG = {
  region: 'ap-southeast-1',
  serviceName: 'execute-api',
  signedHeaders: {
    'content-type': '',
    origin: '',
    'x-amz-date': '',
    host: ''
  },
  canonicalObject: {
    method: 'GET',
    query: '',
    payload: '',
    doubleEscape: false
  }
};
exports.AWS_CONFIG = AWS_CONFIG;